import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const ROUTE_META = {
  "/desistock":            { title: "देशी पर्चा",            subtitle: "Desi Stock Invoice",         icon: "📋", color: "#3B82F6" , section: "पर्चा" },
  "/stockmanagement":      { title: "अंग्रेजी पर्चा",         subtitle: "English Stock Invoice",      icon: "📋", color: "#3B82F6",  section: "पर्चा" },
  "/desistockentry":       { title: "पिछला देशी पर्चा",       subtitle: "Previous Desi Entry",        icon: "📋", color: "#3B82F6",  section: "पर्चा" },
  "/stock":                { title: "पिछला अंग्रेजी पर्चा",   subtitle: "Previous English Entry",     icon: "📋", color: "#3B82F6",  section: "पर्चा" },
  "/editdesistockwithdate":{ title: "देशी आमद",              subtitle: "Desi Stock Inward",          icon: "⬇️", color: "#10B981",  section: "आमद भेजान" },
  "/editstockwithdate":    { title: "अंग्रेजी आमद",           subtitle: "English Stock Inward",       icon: "⬇️", color: "#10B981",  section: "आमद भेजान" },
  "/boxdesi":              { title: "बॉक्स देशी आमद",         subtitle: "Box Desi Inward",            icon: "📦", color: "#10B981",  section: "आमद भेजान" },
  "/boxenglish":           { title: "बॉक्स अंग्रेजी आमद",    subtitle: "Box English Inward",         icon: "📦", color: "#10B981",  section: "आमद भेजान" },
  "/editdesitransferstock":{ title: "देशी भेजान",            subtitle: "Desi Stock Outward",         icon: "⬆️", color: "#6366F1",  section: "आमद भेजान" },
  "/edittransferstock":    { title: "अंग्रेजी भेजान",         subtitle: "English Stock Outward",      icon: "⬆️", color: "#6366F1",  section: "आमद भेजान" },
  "/boxdesitransfer":      { title: "बॉक्स देशी भेजान",       subtitle: "Box Desi Outward",           icon: "📦", color: "#6366F1",  section: "आमद भेजान" },
  "/boxenglishtransfer":   { title: "बॉक्स अंग्रेजी भेजान",  subtitle: "Box English Outward",        icon: "📦", color: "#6366F1",  section: "आमद भेजान" },
  "/expense":              { title: "खर्चा एंट्री",           subtitle: "Daily Expense Entry",        icon: "🧾", color: "#6366F1",  section: "खर्च" },
  "/expensedate":          { title: "पिछला खर्चा",            subtitle: "Previous Expense Entry",     icon: "🧾", color: "#6366F1",  section: "खर्च" },
  "/commissiondesi":       { title: "देसी कमीशन",            subtitle: "Desi Liquor Commission",     icon: "₹", color: "#6366F1",  section: "खर्च" },
  "/commission":           { title: "अंग्रेजी कमीशन",         subtitle: "English Liquor Commission",  icon: "₹", color: "#6366F1",  section: "खर्च" },
  "/employee":             { title: "स्टाफ वेतन",            subtitle: "Employee Salary",            icon: "👤", color: "#6366F1",  section: "खर्च" },
  "/creditdebit":          { title: "नामे / जमा",             subtitle: "Debit & Credit Ledger",      icon: "💳", color: "#6366F1",  section: "खर्च" },
  "/ratedifference":       { title: "दर अंतर",               subtitle: "Rate Difference",            icon: "📉", color: "#6366F1",  section: "खर्च" },
  "/productratedifference":{ title: "प्रोडक्ट दर अंतर",       subtitle: "Product Rate Difference",    icon: "📉", color: "#6366F1",  section: "खर्च" },
  "/phonepaycredit":       { title: "फोनपे जमा",             subtitle: "PhonePe Deposit",            icon: "📱", color: "#6366F1",  section: "खर्च" },
  "/salesreport":          { title: "बिकी रिपोर्ट",           subtitle: "Sales Report",               icon: "📊", color: "#6366F1",  section: "रिपोर्ट" },
  "/report":               { title: "पर्चा रिपोर्ट",          subtitle: "Invoice Report",             icon: "📑", color: "#6366F1",  section: "रिपोर्ट" },
  "/expensereport":        { title: "खर्च रिपोर्ट",           subtitle: "Expense Report",             icon: "📑", color: "#6366F1",  section: "रिपोर्ट" },
  "/printslip":            { title: "प्रिंट पर्चा",           subtitle: "Print Invoice",              icon: "🖨️", color: "#6366F1",  section: "प्रिंट" },
};

export default function PageLayout({ children, actions }) {
  const { pathname } = useLocation();
  const meta = ROUTE_META[pathname] || { title: "Page", subtitle: "", icon: "📄", color: "#6366F1", section: "" };
  const c = meta.color;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", handle);
    return () => window.removeEventListener("resize", handle);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#F0F2F8", display: "flex", flexDirection: "column" }}>

      {/* ═══ PREMIUM HEADER BANNER ═══ */}
      <div style={{
        background: `linear-gradient(130deg, #0f172a 0%, #1e2a45 55%, #1e2a45 100%)`,
        padding: isMobile ? "14px 12px 32px" : "20px 24px 44px",
        position: "relative",
        overflow: "hidden",
        flexShrink: 0,
      }}>
        {/* Decorative blobs — hidden on very small screens */}
        {!isMobile && <>
          <div style={{ position:"absolute", right:-60, top:-60, width:220, height:220, borderRadius:"50%", background: c+"18", pointerEvents:"none" }} />
          <div style={{ position:"absolute", right:80,  top:30,  width:100, height:100, borderRadius:"50%", background: c+"10", pointerEvents:"none" }} />
        </>}
        <div style={{ position:"absolute", left:-30, bottom:-30, width:140, height:140, borderRadius:"50%", background:"rgba(255,255,255,0.03)", pointerEvents:"none" }} />

        {/* Breadcrumb */}
        <div style={{ display:"flex", alignItems:"center", gap:5, marginBottom: isMobile ? 8 : 14, flexWrap:"wrap" }}>
          <Link to="/home" style={{ color:"rgba(255,255,255,0.45)", fontSize: isMobile ? 11 : 12, textDecoration:"none", fontWeight:500 }}>
            🏠 Home
          </Link>
          {meta.section && <>
            <span style={{ color:"rgba(255,255,255,0.2)", fontSize:11 }}>›</span>
            <span style={{ color:"rgba(255,255,255,0.45)", fontSize: isMobile ? 11 : 12, fontWeight:500 }}>{meta.section}</span>
          </>}
          <span style={{ color:"rgba(255,255,255,0.2)", fontSize:11 }}>›</span>
          <span style={{ color: c, fontSize: isMobile ? 11 : 12, fontWeight:700 }}>{meta.title}</span>
        </div>

        {/* Title row */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap: isMobile ? 8 : 12 }}>
          <div style={{ display:"flex", alignItems:"center", gap: isMobile ? 10 : 16, minWidth:0, flex:1 }}>
            {/* Icon */}
            <div style={{
              width: isMobile ? 40 : 52,
              height: isMobile ? 40 : 52,
              borderRadius: isMobile ? 10 : 14,
              flexShrink:0,
              background: c+"25",
              border:`2px solid ${c}55`,
              display:"flex", alignItems:"center", justifyContent:"center",
              fontSize: isMobile ? 19 : 24,
              boxShadow:`0 0 0 ${isMobile ? 4 : 5}px ${c}10`,
              color: c, fontWeight: 700,
            }}>
              {meta.icon}
            </div>
            <div style={{ minWidth:0, flex:1 }}>
              <h1 style={{ margin:0, color:"#fff", fontSize: isMobile ? 15 : 21, fontWeight:800, letterSpacing:-0.3, lineHeight:1.2, wordBreak:"break-word" }}>
                {meta.title}
              </h1>
              <p style={{ margin:"3px 0 0", color:"rgba(255,255,255,0.45)", fontSize: isMobile ? 11 : 13, fontWeight:400 }}>
                {meta.subtitle}
              </p>
            </div>
          </div>

          {/* Action buttons slot */}
          {actions && (
            <div style={{ display:"flex", gap:6, flexWrap:"wrap", alignSelf:"center" }}>
              {actions}
            </div>
          )}
        </div>

        {/* Colored bottom border glow */}
        <div style={{ position:"absolute", bottom:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${c}, ${c}66, transparent)` }} />
      </div>

      {/* ═══ CONTENT CARD (overlaps the banner) ═══ */}
      <div style={{ flex:1, padding: isMobile ? "0 8px 20px" : "0 24px 32px", marginTop: isMobile ? -16 : -22 }}>
        <div style={{
          background:"#fff",
          borderRadius: isMobile ? 10 : 14,
          boxShadow:"0 4px 24px rgba(0,0,0,0.10)",
          overflow:"hidden",
          border:"1px solid rgba(0,0,0,0.05)",
        }}>
          {/* Card top accent strip */}
          <div style={{ height:3, background:`linear-gradient(90deg, ${c}, ${c}55)` }} />
          {children}
        </div>
      </div>

    </div>
  );
}
